import dynamic from 'next/dynamic';

import { type ContextData } from '@common/defaults/ContextData';
import { ThemeID } from '@common/types/ThemeID';

import { type ThemeFontMap } from './ThemeFonts.types';
import { getAssetsPrefix } from './ThemeFonts.utils';

const Apparel = dynamic(() => import('./atoms/Apparel').then((mod) => mod.Apparel), {
    loading: () => null,
});

const Domine = dynamic(() => import('./atoms/Domine').then((mod) => mod.Domine), {
    loading: () => null,
});

const FuturaNowText = dynamic(() => import('./atoms/FuturaNowText').then((mod) => mod.FuturaNowText), {
    loading: () => null,
});

const Gazpacho = dynamic(() => import('./atoms/Gazpacho').then((mod) => mod.Gazpacho), {
    loading: () => null,
});

const Knockout = dynamic(() => import('./atoms/Knockout').then((mod) => mod.Knockout), {
    loading: () => null,
});

const Lato = dynamic(() => import('./atoms/Lato').then((mod) => mod.Lato), {
    loading: () => null,
});

const LeagueGothic = dynamic(() => import('./atoms/LeagueGothic').then((mod) => mod.LeagueGothic), {
    loading: () => null,
});

const Lexia = dynamic(() => import('./atoms/Lexia').then((mod) => mod.Lexia), {
    loading: () => null,
});

const Lora = dynamic(() => import('./atoms/Lora').then((mod) => mod.Lora), {
    loading: () => null,
});

const OpenSans = dynamic(() => import('./atoms/OpenSans').then((mod) => mod.OpenSans), {
    loading: () => null,
});

const Oswald = dynamic(() => import('./atoms/Oswald').then((mod) => mod.Oswald), {
    loading: () => null,
});

const Poppins = dynamic(() => import('./atoms/Poppins').then((mod) => mod.Poppins), {
    loading: () => null,
});

const RobotoMono = dynamic(() => import('./atoms/RobotoMono').then((mod) => mod.RobotoMono), {
    loading: () => null,
});

const Teko = dynamic(() => import('./atoms/Teko').then((mod) => mod.Teko), {
    loading: () => null,
});

const VeloSerifDisplay = dynamic(
    () => import('./atoms/VeloSerifDisplay').then((mod) => mod.VeloSerifDisplay),
    {
        loading: () => null,
    },
);

const WorkSans = dynamic(() => import('./atoms/WorkSans').then((mod) => mod.WorkSans), {
    loading: () => null,
});

const Yrsa = dynamic(() => import('./atoms/Yrsa').then((mod) => mod.Yrsa), {
    loading: () => null,
});

const THEME_FONT_MAP: ThemeFontMap = {
    [ThemeID.AB]: [Poppins, OpenSans],
    [ThemeID.ADMIN]: [Poppins],
    [ThemeID.BI]: [Domine, Lora, Teko, VeloSerifDisplay],
    [ThemeID.BR]: [Lexia, OpenSans],
    [ThemeID.MH]: [Knockout, Lora, RobotoMono, WorkSans],
    [ThemeID.RW]: [FuturaNowText, LeagueGothic, Lora, Oswald],
    [ThemeID.VI]: [OpenSans, Yrsa],
    [ThemeID.VN]: [Lato, Oswald],
    [ThemeID.VPBE]: [Lato, Oswald],
    [ThemeID.VP]: [Lato, Oswald],
    [ThemeID.WH]: [Apparel, Gazpacho, Lora, Poppins],
};

interface Props {
    contextData: ContextData | undefined;
    themeID: ThemeID;
}

export const ThemeFonts = ({ contextData, themeID }: Props) => {
    const assetsPrefix = getAssetsPrefix(contextData);
    const components = THEME_FONT_MAP[themeID];
    return components.map((Component, i) => <Component key={i} assetsPrefix={assetsPrefix} />);
};
